<script lang="ts">
  import { marked, type MarkedOptions } from 'marked'

  export let source: string
  export let options: MarkedOptions = { gfm: false }
  export let isInline = false
  export let matchApp = false
</script>

<div class:matchApp>
  <!-- eslint-disable-next-line svelte/no-at-html-tags -->
  {@html isInline
    ? marked.parseInline(source, options)
    : marked.parse(source, options)}
</div>

<style lang="scss">
  .matchApp {
    white-space: pre-wrap;
  }
</style>
